export function parseConfigurationValuesList(valuesList: string | null | undefined): string[] {
  if (!valuesList) {
    return [];
  }
  const parts = valuesList.split(',').map((s) => s.trim()).filter(Boolean);
  return [...new Set(parts)];
}

export function parseCommaSeparatedValues(value: string): string[] {
  if (!value) {
    return [];
  }
  return value.split(',').map((s) => s.trim()).filter(Boolean);
}

export const configurationV21SelectMenuProps = {
  disableScrollLock: true,
  PaperProps: {
    sx: { maxHeight: 320 },
  },
  anchorOrigin: { vertical: 'bottom' as const, horizontal: 'left' as const },
  transformOrigin: { vertical: 'top' as const, horizontal: 'left' as const },
};
